<template>
  <div class="btn-gray">
    <a :href="url">
      <mdicon name="RepeatVariant" class="flex justify-center text-white" size="90" />
      <h2 class=" text-white text-2xl text-center font-semibold mb-4">{{ title }}</h2>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: 'http://ieducar.duquedecaxias.rj.gov.br/'
    }
  },
  props: {
    title: String
  },
}
</script>